import { render, staticRenderFns } from "./ModelReportComponent.vue?vue&type=template&id=0225401d&scoped=true&"
import script from "./ModelReportComponent.vue?vue&type=script&lang=js&"
export * from "./ModelReportComponent.vue?vue&type=script&lang=js&"
import style0 from "./ModelReportComponent.vue?vue&type=style&index=0&id=0225401d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0225401d",
  null
  
)

export default component.exports